/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PhysioCategoryItem from './physio-category-item';
import PhysioCategoryItemDetail from './physio-category-item-detail';
import PhysioCategoryItemUpdate from './physio-category-item-update';
import PhysioCategoryItemDeleteDialog from './physio-category-item-delete-dialog';

const PhysioCategoryItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PhysioCategoryItem />} />
    <Route path="new" element={<PhysioCategoryItemUpdate />} />
    <Route path=":id">
      <Route index element={<PhysioCategoryItemDetail />} />
      <Route path="edit" element={<PhysioCategoryItemUpdate />} />
      <Route path="delete" element={<PhysioCategoryItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PhysioCategoryItemRoutes;
